<template>
  <div :class="clContainer() + ' custom-tags'">
	<span v-if="hasstar" v-html="hasstar"> </span>
    <span
      v-if="!hideLabelState || state != hideLabelState"
      :class="clSub('label', 'label')"
      >{{ label }}</span
    >
    <p :class="clSub('value', textClass)">{{ text }}</p>

    <vue-tags-input
      :id="id"
      :class="clSub('input', `form__input ${inputClass}`)"
      v-model="data"
      :tags="tags"
      :placeholder="hasValue ? '' : placeholder"
      :add-on-key="addOnKeys"
      @tags-changed="
        (newTags) => {
          tags = newTags;
          validate();
          dataChanged(true);
        }
      "
    />

    <slot name="append" :state="state"></slot>

    <div :class="clSub('errors')">
      <div
        v-for="(error, index) in errors"
        :class="clSub('error')"
        :key="index"
      >
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
import Base from "./Base";
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  extends: Base,
  components: {
    VueTagsInput,
  },
  props: {
    typeClass: {
      type: String,
      default: "tags",
    },
	hasstar: {
		type: String,
	},
    valueTags: {
      type: Array,
      default() {
        return [];
      },
    },
    addOnKeys: {
      type: Array,
      default() {
        return [13];
      },
    },
	hasstar: {
		type: String,
	},
  },
  data() {
    return {
      tags: this.valueTags.map((tag) =>
        typeof tag == "string" ? { text: tag } : tag
      ),
      inputClass: "",
    };
  },
  computed: {
    hasValue() {
      return this.tags.length > 0;
    },
    formData() {
      return this.tags.map((tag) => tag.text);
    },
    text() {
      return this.hasValue
        ? this.tags.map((tag) => tag.text).join(", ")
        : this.noValText;
    },
  },
  created() {
    this.addDataProcessor(this.setTagsData, "set");
  },
  methods: {
    setTagsData(tags) {
      this.tags = Array.isArray(tags)
        ? tags.map((tagText) => {
            return { text: tagText };
          })
        : [];

      return "";
    },
  },
};
</script>

<style lang="scss">
.vue-tags-input.form__input {
	max-width: none;

	.ti-input {
		border: none;
	}
}
</style>
